import { render, staticRenderFns } from "./ListPentest.vue?vue&type=template&id=00ab1132"
import script from "./ListPentest.vue?vue&type=script&lang=js"
export * from "./ListPentest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports